import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { siteUrlsSelector } from '~selectors/SiteUrlsSelectors';
import { AppState } from '~src/app/state/AppState';
import { MapDispatchToProps, MapStateToProps } from '~src/app/utils/ConnectUtils';
import { reorderItem } from '~src/spacesPlatform/actions/ReorderItem';

import { addContentFavorite, removeContentFavorite } from '../../actions/FavoritesActions';
import { getContentDetail } from '../../actions/GetContentDetailAction';
import { selectSpaceInfo } from '../../selectors/SpaceInfoSelectors';
import {
  isDatasourceConnectionSubSpace,
  isPersonalSpace,
  isProjectSpace,
  isRecentsSpace,
  isSingleCollectionSpace,
  IsWorkbookDatasourceSubspaceTab,
  SpaceInfo} from '../../state/SpaceInfo';
import { ContentCardWrapper, ContentCardWrapperDispatchProps, ContentCardWrapperOwnProps, ContentCardWrapperStateProps } from './ContentCardWrapper';

const mapStateToProps: MapStateToProps<ContentCardWrapperStateProps> = (state: AppState, ownProps: ContentCardWrapperOwnProps) => {
  const spaceInfo: SpaceInfo = selectSpaceInfo(state);
  return {
    urls: siteUrlsSelector(state),
    inWorkbookDatasourcesSubspace: IsWorkbookDatasourceSubspaceTab(spaceInfo),
    inDatasourceConnectionsSubspace: isDatasourceConnectionSubSpace(spaceInfo),
    inProjectSpace: isProjectSpace(spaceInfo),
    inRecentsSpace: isRecentsSpace(spaceInfo),
    inCollectionSpace: isSingleCollectionSpace(spaceInfo),
    inPersonalSpace: isPersonalSpace(spaceInfo),
    spaceInfo: spaceInfo,
    drafts: state.drafts?.drafts,
  };
};

const mapDispatchToProps: MapDispatchToProps<ContentCardWrapperDispatchProps> = (dispatch) => bindActionCreators({
  addContentFavorite: addContentFavorite,
  removeContentFavorite: removeContentFavorite,
  getContentDetail: getContentDetail,
  reorderItem: reorderItem
}, dispatch);

export const ConnectedContentCardWrapper: React.ComponentClass<ContentCardWrapperOwnProps> = connect(mapStateToProps, mapDispatchToProps)(ContentCardWrapper);
